export const QUESTION_ADDED_SUCCESS_MESSAGE = "Question has been successfully added";
export const QUESTION_EDITED_SUCCESS_MESSAGE = "Question has been successfully edited";
export const ADD_SUCCESS_MSG_SINGLE_QUESTION = "Question successfully added to Test";
export const ADD_SUCCESS_MSG_MULTIPLE_QUESTIONS = "Questions successfully added to Test";
export const REMOVE_SUCCESS_MSG_SINGLE_QUESTION = "Question has been successfully removed";
export const REMOVE_SUCCESS_MSG_MULTIPLE_QUESTIONS = "Questions have been successfully removed";
export const UPDATE_POINTS_SUCCESS_MSG = "Question Point assignment updated successfully";

// Height offsets for source bank and source select component based on screen size for responsive design.
export const LARGE_VIEW_HEIGHT_OFFSET_BODY: number = 389;
export const SMALL_VIEW_HEIGHT_OFFSET_BODY: number = 107;
export const FOOTER_OFFSET_HEIGHT: number = 40;
export const MEDIUM_SCREEN_BREAKPOINT_PX: number = 640;
export const MEDIUM_SCREEN_HEIGHT_BREAKPOINT_PX: number = 549;
export const SMALL_SCREEN_BREAKPOINT_PX: number = 576;

// Timing constants for accessibility live announcements on the assessment list page.
export const ASSESSMENT_LIST_ANNOUNCEMENT_DURATION_MS: number = 3000;
export const ASSESSMENT_LIST_ANNOUNCEMENT_DELAY_MS: number = 8000;
